import { AiTag } from './AiTag'
export default AiTag
